import { React, useEffect, useState, useRef, useMemo,useCallback } from "react";
 import cogoToast from "cogo-toast"; 
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import * as XLSX from "xlsx";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
 

const MissingCycleDistributions = (props) => {
  const history = useHistory();
  const { cycle_id , cycle_name} = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
 
  const gridRef = useRef();
 

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  useEffect(() => {
    ListCycleDistributions();
 

    return () => { };
  }, []);

 


   
    
  const onBtExport = useCallback(() => {
    setIsLoading(true);
    try {
      // Get all row data from the grid
      const allRowData = [];
      gridRef.current.api.forEachNode((node) => {
        allRowData.push(node.data);
      });

      // Prepare data for export
      const exportData = allRowData.map((row, index) => ({
        "#": index + 1,
        "Name": row.name || "",
        "Age": row.age || "",
        "Gender": row.gender || "",
        "Telephone": row.telephone || "",
        "Camp": row.camp || "",
        "Region": row.region_name || "",
        "District": row.district_name || "",
        "Village": row.village_name || "",
        "Camp Name": row.camp_name || "",
        "Card Label": row.card_label || ""
      }));

      // Create workbook and worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Missing Cycle Distributions");

      // Generate filename with current date
      const fileName = `Missing_Cycle_Distributions_${cycle_name || 'Export'}_${new Date().toISOString().split('T')[0]}.xlsx`;

      // Write file
      XLSX.writeFile(wb, fileName);
      
      cogoToast.success("Data exported to Excel successfully", {});
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      cogoToast.error("Failed to export data to Excel", {});
    } finally {
      setIsLoading(false);
    }
  }, [cycle_name]);

  
  const ListCycleDistributions = () => {
    console.clear();
    console.log({"cycle_id": cycle_id  })
    setIsLoading(true);

    genericPost(ENDPOINTS.MISSING_CYCLE_DISTRIBUTIONS,{"cycle_id": cycle_id  })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
         
          setList(responseData);
    
          }
        
        } else {
          cogoToast.error(res.data.message, {});
        }
      
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });

   
  };

  return (
    <div>
      <h1>MISSING CYCLE DISTRIBUTIONS [ {list.length} ]</h1>
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/"> EBMS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/"> CYCLE DISTRIBUTIONS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <Link to="/">  {cycle_name} </Link>
        </BreadcrumbItem>
      </Breadcrumb>

      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>

      <div className="card-body">
      <a href="javascript:void(0)" onClick={onBtExport} class="btn btn-primary">
                                            Export To Excel
                                        </a>
        <div className="ag-theme-alpine">
          <AgGridReact
            suppressMenuHide={true}
          
            ref={gridRef}
           
            onGridReady={(params) => {
              
            }}
            rowData={list}
            domLayout={"autoHeight"}
            animateRows={true}
            pagination={true}
            paginationPageSize={100}
            defaultColDef={defaultColDef}
            resizable={true}
            enableCellTextSelection={true}
            suppressCellSelection={true}
            columnDefs={[
              {
                headerName: "#",
                filter: false,
                maxWidth: 70,
                sortable: true,
                valueFormatter: function (params) {
                  return `${parseInt(params.node.id) + 1}`;
                },
              },
              {
                headerName: "Name",
                field: "name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Age",
                field: "age",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Gender",
                field: "gender",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Telephone",
                field: "telephone",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Camp",
                field: "camp",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Region",
                field: "region_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "District",
                field: "district_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Village",
                field: "village_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Camp Name",
                field: "camp_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Card Label",
                field: "card_label",
                sortable: true,
                filter: true,
              }
            ]}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
};

export default MissingCycleDistributions;
